import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { externalLinks } from '../data/mock';
import { ExternalLink, Phone, MessageCircle } from 'lucide-react';

const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer className="bg-black border-t border-white/10 py-12">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8">
          {/* Brand */}
          <div>
            <h3 className="text-xl font-bold text-white mb-2">강남놀이터 코엑스점</h3>
            <p className="text-white/60 text-sm">{t('businessInfo')}</p>
          </div>
          
          {/* Links */}
          <div className="flex flex-wrap gap-4 md:justify-end">
            <a
              href={externalLinks.naverStore}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1 text-white/60 hover:text-[#00FFD1] text-sm transition-colors"
            >
              {t('naverReserve')}
              <ExternalLink size={12} />
            </a>
            <a
              href={externalLinks.naverPlace}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1 text-white/60 hover:text-[#00FFD1] text-sm transition-colors"
            >
              {t('naverPlace')}
              <ExternalLink size={12} />
            </a>
            <a
              href={externalLinks.instagram}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1 text-white/60 hover:text-[#00FFD1] text-sm transition-colors"
            >
              {t('instagram')}
              <ExternalLink size={12} />
            </a>
            <a
              href={externalLinks.kakao}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1 text-white/60 hover:text-[#00FFD1] text-sm transition-colors"
            >
              <MessageCircle size={12} />
              {t('kakaoContact')}
            </a>
            <a
              href={externalLinks.phone}
              className="inline-flex items-center gap-1 text-white/60 hover:text-[#00FFD1] text-sm transition-colors"
            >
              <Phone size={12} />
              {t('call')}
            </a>
          </div>
        </div>
        
        <div className="border-t border-white/10 pt-6 text-center">
          <p className="text-white/40 text-xs">
            © 2025 강남놀이터 코엑스점. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;